import { StoreAction } from "../types/store"
import { CurrentClient } from "../lib/currentClient"
import { Client } from "../lib/client"
import { User } from "@auth0/auth0-react"
import {
  LOGIN,
  LoginAction,
  LOGOUT,
  SET_CLIENT_CONFIG,
  SET_CLIENTS,
  SET_CURRENT_CLIENT, SetClientConfigAction,
  SetClientsAction,
  SetCurrentClientAction
} from "./actions";
import { ClientConfig } from "../lib/clientConfig";

export interface StoreState {
  user: User | null
  currentClient: CurrentClient | null
  clients: Client[]
  clientConfig: ClientConfig  | null
}

export const initialState: StoreState = {
  user: null,
  currentClient: null,
  clients: [],
  clientConfig: null,
}

export default function reducer(state: StoreState, action: StoreAction): StoreState {
  switch (action.type) {
    case LOGIN: {
      const { user } = action as LoginAction
      return {
        ...state,
        user,
      }
    }
    case SET_CLIENTS: {
      const { clients } = action as SetClientsAction
      return {
        ...state,
        clients,
      }
    }
    case SET_CURRENT_CLIENT: {
      const { currentClient } = action as SetCurrentClientAction
      return {
        ...state,
        currentClient,
      }
    }
    case SET_CLIENT_CONFIG: {
      const { clientConfig } = action as SetClientConfigAction
      return {
        ...state,
        clientConfig,
      }
    }
    case LOGOUT: {
      return initialState
    }

    default:
      return state
  }
}
